/** App locale (localStorage / i18n) → Google Translate language code */
export const APP_TO_GOOGLE_LANG = {
  en: 'en',
  vn: 'vi',
  jp: 'ja',
  kr: 'ko',
  tw: 'zh-TW',
  cn: 'zh-CN',
  tr: 'tr',
  my: 'ms',
  th: 'th',
  np: 'ne',
  ar: 'ar',
  ru: 'ru',
  in: 'hi',
}

/** Google Translate language code → app locale */
export const GOOGLE_TO_APP_LOCALE = {
  en: 'en',
  vi: 'vn',
  ja: 'jp',
  ko: 'kr',
  'zh-TW': 'tw',
  'zh-CN': 'cn',
  zh: 'cn',
  tr: 'tr',
  ms: 'my',
  th: 'th',
  ne: 'np',
  ar: 'ar',
  ru: 'ru',
  hi: 'in',
}

export const GOOGLE_INCLUDED_LANGUAGES = 'en,ja,ko,vi,ne,zh-TW,zh-CN,tr,ms,ru,ar,th,hi'

export function appLocaleToGoogleLang(appLocale) {
  const key = String(appLocale || 'en').trim().toLowerCase()
  return APP_TO_GOOGLE_LANG[key] || key || 'en'
}

export function googleLangToAppLocale(googleLang) {
  const key = String(googleLang || 'en').trim()
  if (GOOGLE_TO_APP_LOCALE[key]) return GOOGLE_TO_APP_LOCALE[key]
  const lower = key.toLowerCase()
  if (GOOGLE_TO_APP_LOCALE[lower]) return GOOGLE_TO_APP_LOCALE[lower]
  return 'en'
}
